function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgMoney = function SvgMoney(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.883 511.883",
    style: {
      enableBackground: "new 0 0 511.883 511.883"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC6BB"
    },
    d: "M238.913,511.883c-76.967,0-139.359-62.393-139.359-139.359S161.946,233.15,238.913,233.15 c76.982,0,139.375,62.407,139.375,139.374S315.895,511.883,238.913,511.883z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC6BB"
    },
    d: "M294.12,356.012h59.533V56.721c0-16.418-13.357-29.759-29.76-29.759 c-16.418,0-29.773,13.341-29.773,29.759L294.12,356.012L294.12,356.012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC6BB"
    },
    d: "M229.274,329.065h59.518V29.759C288.792,13.356,275.436,0,259.034,0 c-16.419,0-29.76,13.355-29.76,29.759V329.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC6BB"
    },
    d: "M164.414,356.012h59.518V56.721c0-16.418-13.356-29.759-29.759-29.759 c-16.418,0-29.759,13.341-29.759,29.759V356.012z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC6BB"
    },
    d: "M99.554,372.524h59.518V110.631c0-16.418-13.341-29.759-29.759-29.759 c-16.402,0-29.759,13.341-29.759,29.759V372.524z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 31.882,
    y: 106.132,
    style: {
      fill: "#8CC153"
    },
    width: 448.12,
    height: 234.73
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D468"
    },
    d: "M95.898,138.14h320.083c0,17.684,14.326,32.009,32.01,32.009v106.694 c-17.684,0-32.01,14.324-32.01,32.008H95.898c0-17.684-14.325-32.008-32.008-32.008V170.149 C81.574,170.149,95.898,155.824,95.898,138.14z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#8CC153"
    },
    cx: 255.94,
    cy: 223.492,
    r: 53.35
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC6BB"
    },
    d: "M436.055,289.45l0.016-0.016c4.857-9.451,5.764-20.229,2.531-30.353 c-3.25-10.123-10.232-18.387-19.684-23.261c-5.701-2.937-11.826-4.437-18.199-4.437c-14.98,0-28.557,8.279-35.414,21.589 l-71.185,137.97l73.123,34.867l68.797-136.328L436.055,289.45z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoney, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/money.bdd4cba8.svg";
export { ForwardRef as ReactComponent };